import styles from "./SettingsSubscription.module.scss";
import Card from "../../../common/Card";
import React from "react";
import CardEmpty from "../../../common/CardEmpty";
import useFormat from "../../../util/useFormat";
import clsx from "clsx";
import Button from "../../../common/Button";
import useSettingsSubscription from "./useSettingsSubscription";
import useProject from "../../../util/useProject";
import {Content, ContentFixed} from "../../../common/Content";
import {SettingsMenuMobile} from "../Settings";
import {SettingsContent} from "../SettingsContent";
import {SettingsTopMenu} from "../SettingsTopMenu";

const SettingsSubscription = () => {
  const {formatDate, formatAmount} = useFormat();
  const {expired, expirationDate} = useProject();

  const {t, tApp, orders, renew, renewing, orderSuccess} = useSettingsSubscription();

  const btnRenew = <Button type="button" variant="primary" onClick={renew} disabled={renewing}>
    {t("btn_renew_subscription")}
  </Button>;

  return (
    <Content>
      <ContentFixed>
        <SettingsTopMenu title="header_title_settings_subscription"/>

        <SettingsMenuMobile/>
      </ContentFixed>

      <SettingsContent>
        {orderSuccess && <div className={styles.orderSuccess}>{t("subscriptions_success")}</div>}

        {expired && <div className={clsx("card", styles.card, styles.projectExpired)}>
          <p><strong>{tApp("expired_project_card_title")}</strong></p>
          <p>{tApp("expired_project_card_text", {date: formatDate(expirationDate)})}</p>
          <p>{btnRenew}</p>
        </div>}

        <Card ifCond={!expired} padding>
          <p>{t("subscriptions_page_info")}</p>
          <p>{t("subscriptions_project_expiration")} <strong>{formatDate(expirationDate)}</strong></p>

          <div>{btnRenew}</div>
        </Card>

        <Card title={t("subscriptions_history_title")}>
          {!orders && <CardEmpty>{t("subscriptions_loading")}</CardEmpty>}
          {orders && orders.length === 0 && <CardEmpty>{t("subscriptions_no_order")}</CardEmpty>}

          {orders && orders.length > 0 && <div className={clsx(styles.order, styles.header)}>
            <div className={clsx(styles.orderCol, styles.orderId)}>{t("subscriptions_header_reference")}</div>
            <div className={clsx(styles.orderCol, styles.orderCreateTime)}>{t("subscriptions_header_date")}</div>
            <div className={clsx(styles.orderCol, styles.orderAmount)}>{t("subscriptions_header_amount")}</div>
            <div className={clsx(styles.orderCol, styles.orderNewExpirationDate)}>
              {t("subscriptions_header_new_expiration_date")}
            </div>
          </div>}

          {(orders || []).map(o => {
            return <div key={o.id} className={clsx(styles.order, "hover-non-selectable")}>
              <div className={clsx(styles.orderCol, styles.orderId)}>{o.id}</div>
              <div className={clsx(styles.orderCol, styles.orderCreateTime)}>{formatDate(o.createTime)}</div>
              <div
                className={clsx(styles.orderCol, styles.orderAmount)}>{formatAmount(o.amountTotal / 100, o.currency.toUpperCase())}</div>
              <div
                className={clsx(styles.orderCol, styles.orderNewExpirationDate)}>{formatDate(o.newExpirationDate)}</div>
            </div>
          })}
        </Card>
      </SettingsContent>
    </Content>
  );
};

export default SettingsSubscription;
